export { default } from "./ChannelDetailsSkeleton";
